export const MUI_PRO_X_KEY =
  'a71313b8ab589609a973516bfb1abe71Tz0xMjI3MTEsRT0xNzk2NDI4Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=';
